<template lang="pug">
v-dialog(v-model="show", persistent, max-width="50%")
  v-card.cardAntecipacao.Poppins(v-if="fatura")
    v-card-title.Poppins
      v-flex.md8
        .title Antecipação
      v-flex.md4.text-xs-right(v-if="$root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO")
        .body-1(style="cursor: pointer;", @click="$emit('showFatura', fatura);") veja detalhes
    v-card-text
      v-card.pa-4.cardAntecipacao
        v-layout(row, wrap)
          v-flex.md12
            v-layout(row, wrap)
              v-flex.md12
                div(style="padding: 20px; border-radius: 10px; border: 1px solid #CCCCCC;")
                  .subheading.font-weight-medium.Poppins Valor a receber: {{ fatura.repasse.valor | currency }}
                  .subheading.Poppins.gray--text Período de apuração: {{ $dayjs(fatura.data_inicio).format("DD/MM/YYYY")}} - {{ $dayjs(fatura.data_fim).format("DD/MM/YYYY") }}.
            v-layout(row, wrap)
              v-flex.md12
                li.mb-3.mt-3
                  .body-1.Poppins A transferência do valor antecipado ocorrerá no dia
                    span.ml-1(style="text-decoration: underline;") {{$dayjs(fatura.repasse.data_repasse).format("DD/MM/YYYY")}} (próximo dia útil)
                    span.ml-1 , e será enviada para
                    span.ml-1 {{ dadosBancarios }}.
                li.mb-3
                  .body-1.Poppins Feriados municipais da cidade de Rio Pomba (sede da empresa) não são considerados como dia útil.
                li.mb-3
                  .body-1.Poppins Para evitar atrasos no recebimento, certifique-se que os dados bancários estão corretos e em nome da pessoa física ou jurídica titular do contrato.
                li.mb-3
                  .body-1.Poppins Ao clicar em CONFIRMAR, o sistema efetivará a contabilidade de todos os pedidos cofirmados e compreendidos no período de apuração. Sendo assim, não será possível solicitar o cancelamento destes pedidos.
    v-card-actions.mr-4.pb-3
        v-spacer
        v-btn.btnConfirmar(color="primary", @click="confirm(fatura)", :loading="loading", :disabled="loading") Confirmar
        v-btn(flat, @click="close()", :disabled="loading") Fechar

</template>

<script>

export default {
  props: {
    showFatura: {
      type: Function,
      required: false,
      default: () => {},
    },
    refresh: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data () {
    return {
      show: false,
      loading: false,
      fatura: null,
    }
  },
  computed: {
    dadosBancarios(){
      const vm = this;
      if (!vm.fatura) return null;
      const { venda } = vm.fatura;
      const { dados_faturamento } = venda;
      const bancos = vm.getBancos();
      const banco = dados_faturamento.tipo_dado_bancario == 0 && bancos && bancos.length ? `do banco ${_.find(bancos, {codigo : dados_faturamento.banco}) || ''}` : ``;
      return dados_faturamento.tipo_dado_bancario == 1 ? `a chave PIX ${dados_faturamento.chave_pix}` : `a agência ${dados_faturamento.agencia} e conta ${dados_faturamento.conta} ${banco}`;
    }
  },
  methods: {
    async getBancos(){
      const vm = this;
      const { data: bancos } = await vm.$axios.get('/bancos');
      return bancos;
    },
    async confirm(fatura){
      const vm = this;
      vm.loading = true;

      if (vm.$root.userIsAdmin) {
        vm.loading = false;
        return window.getApp.$emit("APP_ALERT", { color: "red", text: 'O usuário não tem permissão para realizar a ação!' });
      }

      try {
        let response = await vm.$axios.post("/fatura", fatura);
        fatura = Object.assign(fatura, response.data);
        window.getApp.$emit("APP_ALERT", { color: "success", text: "Antecipação Solicitada" });
        vm.$forceUpdate();
        // vm.$emit('refresh');
        window.getApp.$emit("REFRESH_FATURAS")
        vm.close();
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : "Ocorreu um erro ao solicitar a antecipação. Tente novamente.";
        window.getApp.$emit("APP_ALERT", { color: "red", text: err });
      } finally {
        vm.loading = false;
      }
    },
    open(fatura){
      const vm = this;
      vm.fatura = fatura;
      vm.show = true;
    },
    close(){
      const vm = this;
      vm.fatura = null;
      vm.show = false;
    }
  }
}
</script>

<style scoped>

.cardAntecipacao{
  box-shadow:none !important;
  background-color: #eaeaea;
}

.btnConfirmar{
  color: #fff;
  border-radius:5px;
}
</style>
